import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { PracticeAreas } from './pages/PracticeAreas';
import { Conveyancing } from './pages/Conveyancing';
import { Team } from './pages/Team';
import { Insights } from './pages/Insights';
import { FAQs } from './pages/FAQs';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="about" element={<About data-id="element-7" />} data-id="element-6" />
          <Route path="practice-areas" element={<PracticeAreas data-id="element-9" />} data-id="element-8" />
          <Route path="conveyancing" element={<Conveyancing data-id="element-11" />} data-id="element-10" />
          <Route path="team" element={<Team data-id="element-13" />} data-id="element-12" />
          <Route path="insights" element={<Insights data-id="element-15" />} data-id="element-14" />
          <Route path="faqs" element={<FAQs data-id="element-17" />} data-id="element-16" />
          <Route path="contact" element={<Contact data-id="element-19" />} data-id="element-18" />
          <Route path="privacy" element={<Privacy data-id="element-21" />} data-id="element-20" />
          <Route path="terms" element={<Terms data-id="element-23" />} data-id="element-22" />
        </Route>
      </Routes>
    </BrowserRouter>;
}